import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  Typography,
} from '@material-ui/core';
import BallotIcon from '@material-ui/icons/Ballot';
import { getSummaryData } from '../utils/logExtractors';

function RouterLogSummary({ selectedLog, classes }) {
  if (!selectedLog) return null;
  
  const summary = getSummaryData(selectedLog);
  return (
    <Card style={{ marginTop: 5 }}>
      <CardHeader
        avatar={<BallotIcon color="primary" />}
        title="Summary"
      />
      <CardContent>
        <Grid container spacing={2}>
          
          {/* Full-width rows */}
          <Grid item xs={12}>
            <Typography>
              <strong>Transaction ID:</strong> {summary.transactionId}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography>
              <strong>Timestamp:</strong> {summary.timestamp}
            </Typography>
          </Grid>

          {/* Two-column layout */}
          <Grid item xs={12} sm={6}>
            <Typography>
              <strong>Client Name:</strong>{" "}
              {summary.clientName}{" "}
              {summary.clientAbbreviation
                ? `(${summary.clientAbbreviation})`
                : ""}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography>
              <strong>Client Number:</strong> {summary.clientNumber}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography>
              <strong>Data Source:</strong> {summary.dataSource}
            </Typography>
          </Grid>

        </Grid>
      </CardContent>
    </Card>
  );
}

RouterLogSummary.propTypes = {
  selectedLog: PropTypes.object,
  classes: PropTypes.object.isRequired,
};

export default RouterLogSummary;